import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EntitlementService } from '../../services/entitlement.service';
import { Ship } from '../../Ship';
import { ShipService } from '../../services/ship.service';
import { Router } from '@angular/router';
import { Merchant } from '../../Merchant';
import { UntypedFormGroup } from '@angular/forms';
import { MessageService } from 'src/app/services/message.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ship-register-merchants',
  templateUrl: './ship-register-merchants.component.html',
  styleUrls: ['./ship-register-merchants.component.css']
})
export class ShipRegisterMerchantsComponent implements OnInit {
  @Output() registerCancel = new EventEmitter();
  @Input() ship: Ship;
  merchantsForm: UntypedFormGroup;
  save_ba_btn_spinner: string;
  stripBASuccessFail = '';
  stripBACircle = '';
  stripBACircleCheck = '';
  stripBAStatus = '';
  merchants: Merchant[] = [];
  registerMerchants: Merchant[] = [];
  checked: boolean = true;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private router: Router,
    private messageService: MessageService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.initForm();

    this.shipService.getMerchantsByShipClass(this.ship.shipClass).subscribe(
      (data: Merchant[]) => {
        this.merchants = data;
        this.registerMerchants = data;
      },
      (error) => {}
    );
  }

  initForm() {
    // @ts-ignore
    this.merchantsForm = new UntypedFormGroup({});
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  onCancel() {
    this.registerCancel.emit();
  }

  check(event) {
    const target = event.target;

    if (target.checked) {
      this.registerMerchants.push(
        this.merchants.filter((merch) => merch.merchantId === target.id)[0]
      );
    } else {
      this.registerMerchants = this.registerMerchants.filter(
        (merchant) => merchant.merchantId !== target.id
      );
    }
  }

  selectAll(event) {
    const target = event.target;
    this.registerMerchants = []; // Clear array so no duplicates

    this.merchants.forEach((merchant) => {
      (<HTMLInputElement>document.getElementById(merchant.merchantId)).checked =
        target.checked;
    });

    if (target.checked) {
      this.registerMerchants = this.merchants;
    } else {
      this.registerMerchants = this.merchants.filter((merchant: Merchant) =>
        merchant.descriptionLong === 'NAVY DISBURSING'
      );
      (<HTMLInputElement>document.getElementById(this.registerMerchants[0].merchantId)).checked = true;
      (<HTMLInputElement>document.getElementById(this.registerMerchants[0].merchantId)).disabled = true;
    }
  }

  validMerchants() {
    return this.registerMerchants.length < 1 && this.merchants.length > 0;
  }

  onSubmit() {
    // Start the save
    this.save_ba_btn_spinner = 'fa fa-spinner fa-spin';

    this.ship.merchants = this.registerMerchants;

    this.shipService.registerShip(this.ship).subscribe(
      () => {
        this.save_ba_btn_spinner = '';
        this.stripBAStatus = 'Ship Registration Success.';
        this.stripBASuccessFail = 'actionSucess';
        this.stripBACircleCheck = 'fa fa-check-circle fa-2x';
        this.stripBACircle = 'actionCircle';
      },
      error => {
        this.messageService.error(error.error);
        this.save_ba_btn_spinner = '';
        this.stripBAStatus = error.statusText;
      },
      () => {
        this.shipService.storeShipProfile(this.ship);
        this.shipService.storeShipProfileResult(this.ship);
        this.toastrService.success(this.ship.shipName + ' registration is complete');
        this.router.navigate(['/shipProfiles/roundtrips']);
      }
    );
  }

}
